/* Favoritter: stjerne på produktkort og produktsider, liste i Varebestilling.
   Innlogget: lagres i kundemetafeltet custom.favoritter via Workeren byuti-favoritter.
   Gjest: lagres i nettleseren og flettes inn ved innlogging.

   [data-fav="<id>" data-fav-h="<handle>"]  stjerneknapp (lages også av byuti-butikk.js)
   [data-b3-favliste]                       favorittlisten (sections/b3-favorittliste.liquid)
   [data-b3-favantall]                      antall i headeren */
(() => {
  if (window.__b3Fav) return;
  window.__b3Fav = true;
  const C = window.ByutiFav || {};
  const LOKAL = 'byuti-fav-gjest';
  const SPEIL = 'byuti-fav-' + (C.kunde || 'gjest');
  const les = (k) => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } };
  const skriv = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };

  /* Innlogget: listen fra kundemetafeltet (Liquid) er fasit ved innlasting */
  let liste = C.kunde && Array.isArray(C.produkter) ? C.produkter : les(C.kunde ? SPEIL : LOKAL);
  const har = (id) => liste.some((x) => x.id === String(id));

  const STJERNE = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2l2.6 5.6 6.1.7-4.5 4.2 1.2 6.1L12 16.8l-5.4 3 1.2-6.1-4.5-4.2 6.1-.7z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  window.b3FavKnapp = (id, h, ekstra) =>
    '<button type="button" class="b3-fav' + (ekstra ? ' ' + ekstra : '') + (har(id) ? ' b3-fav--paa' : '') + '" data-fav="' + id + '" data-fav-h="' + h + '" aria-pressed="' + har(id) + '" aria-label="Lagre som favoritt" title="Lagre som favoritt">' + STJERNE + '</button>';

  function oppdater() {
    document.querySelectorAll('[data-fav]').forEach((b) => {
      const p = har(b.dataset.fav);
      b.classList.toggle('b3-fav--paa', p);
      b.setAttribute('aria-pressed', p);
      b.setAttribute('aria-label', p ? 'Fjern fra favoritter' : 'Lagre som favoritt');
    });
    document.querySelectorAll('[data-b3-favantall]').forEach((e) => { e.textContent = liste.length || ''; e.hidden = !liste.length; });
  }

  /* Kall til Workeren går i kø, så raske klikk ikke overskriver hverandre */
  let ko = Promise.resolve();
  function send(data) {
    if (!C.kunde) return Promise.resolve(null);
    ko = ko.then(() => fetch(C.url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ kunde: C.kunde, ts: C.ts, sig: C.sig }, data)) })
      .then((r) => r.json()).then((d) => {
        if (d && d.ok) { liste = d.produkter; skriv(SPEIL, liste); oppdater(); }
        return d;
      }).catch(() => null));
    return ko;
  }

  function toast(t) {
    let e = document.querySelector('.bt-toast');
    if (!e) { e = document.createElement('div'); e.className = 'bt-toast'; e.setAttribute('role', 'status'); document.body.appendChild(e); }
    e.innerHTML = t; e.classList.add('bt-toast--vis');
    clearTimeout(e._t); e._t = setTimeout(() => e.classList.remove('bt-toast--vis'), 2600);
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const id = String(b.dataset.fav), h = b.dataset.favH;
    if (har(id)) {
      liste = liste.filter((x) => x.id !== id);
      send({ handling: 'fjern', produkt: { id } });
      toast('Fjernet fra favoritter');
    } else {
      liste = [{ id, h, t: Date.now() }, ...liste];
      send({ handling: 'legg_til', produkt: { id, h } });
      toast('Lagret i favoritter · <a href="' + C.side + '">Se alle</a>' + (C.kunde ? '' : '<br><small>Logg inn for å ha dem på alle enheter</small>'));
    }
    skriv(C.kunde ? SPEIL : LOKAL, liste);
    oppdater();
    if (b.closest('[data-b3-favliste]') && !har(id)) { const k = b.closest('.bt-kort'); if (k) k.remove(); tellListe(); }
  }, true);

  /* Stjerne ved tittelen på produktsiden */
  function produktside() {
    if (!C.produkt || document.querySelector('.b3-fav--side')) return;
    const h1 = document.querySelector('main h1, #MainContent h1, h1');
    if (!h1) return;
    const vrapp = document.createElement('span');
    vrapp.className = 'b3-fav-tittel';
    h1.parentNode.insertBefore(vrapp, h1);
    vrapp.appendChild(h1);
    vrapp.insertAdjacentHTML('beforeend', window.b3FavKnapp(C.produkt.id, C.produkt.h, 'b3-fav--side'));
  }

  /* Favorittlisten */
  const venter = (sjekk, ms) => new Promise((ok) => { const t0 = Date.now(); (function l() { if (sjekk() || Date.now() - t0 > ms) ok(); else setTimeout(l, 60); })(); });
  function tellListe() {
    document.querySelectorAll('[data-b3-favliste]').forEach((rot) => {
      const n = rot.querySelectorAll('.bt-kort').length;
      const tom = rot.querySelector('[data-b3-favtom]'); if (tom) tom.hidden = n > 0;
    });
  }
  async function visListe() {
    const rotter = document.querySelectorAll('[data-b3-favliste]');
    if (!rotter.length) return;
    await venter(() => window.btKort, 5000);
    if (!window.btKort) return;
    const data = await Promise.all(liste.slice(0, 120).map((x) =>
      fetch('/products/' + encodeURIComponent(x.h) + '?view=kortdata', { credentials: 'same-origin' })
        .then((r) => r.ok ? r.json() : null).catch(() => null)));
    const varer = data.filter(Boolean).map((p, i) => window.btKort.pakk(p, i));
    rotter.forEach((rot) => {
      const grid = rot.querySelector('.bt-grid');
      grid.innerHTML = varer.map((p) => window.btKort.kort(p, '')).join('');
      tellListe();
    });
    oppdater();
  }

  async function start() {
    oppdater();
    produktside();
    if (C.kunde) {
      const gjest = les(LOKAL);
      const d = await send(gjest.length ? { handling: 'flett', produkter: gjest } : { handling: 'hent' });
      if (d && d.ok && gjest.length) { try { localStorage.removeItem(LOKAL); } catch (e) {} }
    }
    visListe();
    if (location.hash === '#favoritter') { const m = document.getElementById('favoritter'); if (m) m.scrollIntoView(); }
  }
  /* Kort som tegnes senere (søk, lister) får riktig stjerne */
  new MutationObserver(() => { clearTimeout(window.__b3FavT); window.__b3FavT = setTimeout(oppdater, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
